<span class="eui-button__container">
    <span *ngIf="isLoading" class="eui-button__loading-icon">
        <eui-icon [isLoading]="true"></eui-icon>
    </span>
    <ng-content></ng-content>
</span>
